import { OnInit, Component } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { trigger, transition, style, animate } from '@angular/animations';
import { NotificationService } from '../services/notification.service';
import { CacheKey } from '../constants/cachekey.constants';
import { NotificationType } from '../../common/enums/notification-type.enum';
import { CacheService } from '../services/cache.service';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-notification',
  templateUrl: '../templates/template1/views/notification.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/notification.component.less'
  ],
  animations: [
    trigger('slideEnter', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class NotificationComponent implements OnInit {

  isClose = true;
  isSelected = true;
  notificationType = NotificationType;
  notificationConfig: Notification = {
    title: '',
    content: '',
    type: '',
    timeout: 3000,
    alwaysVisible: false,
    isClose: true
  };

  messageConfig: Notification = {
    title: '',
    content: '',
    type: '',
    timeout: 3000,
    alwaysVisible: true,
    isSelected: true,
  };


  constructor(private notificationService: NotificationService,
    private _cacheService: CacheService) {
  }

  ngOnInit(): void {
    this.listenNotification();
  }

  /**
   * Listen Notification
   * @returns void
   */
  listenNotification(): void {
    this.notificationService.getNotification().subscribe((data: Notification) => {
      if (data) {
        if (data.alwaysVisible) {
          this.messageConfig = data;
          this.isSelected = false;
        } else {
          this.notificationConfig = data;
          this.isClose = false;
        }
        setTimeout(() => {
          this.hideNotification();
        }, data.timeout);
      }
    });
  }

  /**
   * hide Notification
   * @returns void
   */
  hideNotification(): void {
    this.isClose = true;
  }

  hideMessage(): void {
    this._cacheService.set(CacheKey.CanShowNotification, JSON.stringify(false));
    this.isSelected = true;
  }

}
